export default "__VITE_ASSET__bee31ad3__"